import { jsx as C } from "react/jsx-runtime";
const t = ({
  size: L
}) => {
  switch (L) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M3.54019 13.6683C3.20341 13.6683 2.91836 13.5516 2.68502 13.3183C2.45169 13.085 2.33502 12.7999 2.33502 12.4631V3.54013C2.33502 3.20335 2.45169 2.91829 2.68502 2.68496C2.91836 2.45163 3.20341 2.33496 3.54019 2.33496H8.00802V3.33496H3.54019C3.48886 3.33496 3.44186 3.35635 3.39919 3.39913C3.35641 3.44179 3.33502 3.48879 3.33502 3.54013V12.4631C3.33502 12.5145 3.35641 12.5615 3.39919 12.6041C3.44186 12.6469 3.48886 12.6683 3.54019 12.6683H8.00802V13.6683H3.54019ZM10.8222 10.8478L10.1299 10.1246L11.753 8.50163H6.06586V7.50163H11.753L10.1299 5.87863L10.8222 5.15546L13.6684 8.00163L10.8222 10.8478Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H12.0095V5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H12.0095V20.5H5.30775ZM16.2308 16.2692L15.1923 15.1845L17.627 12.75H9.09625V11.25H17.627L15.1923 8.8155L16.2308 7.73075L20.5 12L16.2308 16.2692Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M4.42479 17.0817C4.00382 17.0817 3.6475 16.9359 3.35583 16.6442C3.06417 16.3525 2.91833 15.9962 2.91833 15.5752V4.4215C2.91833 4.00053 3.06417 3.64421 3.35583 3.35254C3.6475 3.06087 4.00382 2.91504 4.42479 2.91504H10.0096V4.16504H4.42479C4.36063 4.16504 4.30188 4.19177 4.24854 4.24525C4.19507 4.29858 4.16833 4.35733 4.16833 4.4215V15.5752C4.16833 15.6394 4.19507 15.6982 4.24854 15.7515C4.30188 15.805 4.36063 15.8317 4.42479 15.8317H10.0096V17.0817H4.42479ZM13.5273 13.5561L12.6619 12.6521L14.6908 10.6234H7.58188V9.37337H14.6908L12.6619 7.34462L13.5273 6.44066L17.085 9.99837L13.5273 13.5561Z",
          fill: "currentColor"
        }
      );
  }
}, H = ({
  size: L
}) => {
  switch (L) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M3.38166 14.136C2.96188 14.136 2.60416 13.9882 2.30849 13.6925C2.01282 13.3968 1.86499 13.0391 1.86499 12.6193V3.38166C1.86499 2.96188 2.01282 2.60416 2.30849 2.30849C2.60416 2.01282 2.96188 1.86499 3.38166 1.86499H8.03232V3.38166H3.38166V12.6193H8.03232V14.136H3.38166ZM10.6153 11.5252L9.56716 10.435L11.2432 8.75882H5.96866V7.24216H11.2432L9.56716 5.56599L10.6153 4.47582L14.136 8.00049L10.6153 11.5252Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M5.06974 21.2014C4.44007 21.2014 3.90349 20.9797 3.45999 20.5362C3.01649 20.0927 2.79474 19.5561 2.79474 18.9264V5.06992C2.79474 4.44026 3.01649 3.90367 3.45999 3.46017C3.90349 3.01667 4.44007 2.79492 5.06974 2.79492H12.0457V5.06992H5.06974V18.9264H12.0457V21.2014H5.06974ZM15.9202 17.2852L14.348 15.6499L16.862 13.1357H8.95024V10.8607H16.862L14.348 8.34642L15.9202 6.71117L21.2012 11.9982L15.9202 17.2852Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M4.22683 17.6688C3.7021 17.6688 3.25495 17.484 2.88537 17.1145C2.51579 16.7449 2.33099 16.2977 2.33099 15.773V4.22591C2.33099 3.70119 2.51579 3.25404 2.88537 2.88445C3.25495 2.51487 3.7021 2.33008 4.22683 2.33008H10.0402V4.22591H4.22683V15.773H10.0402V17.6688H4.22683ZM13.2689 14.4053L11.9587 13.0426L14.0537 10.9474H7.46058V9.05154H14.0537L11.9587 6.95633L13.2689 5.59362L17.6697 9.99945L13.2689 14.4053Z",
          fill: "currentColor"
        }
      );
  }
}, V = ({
  size: L = "md",
  weight: r = "default"
}) => {
  switch (r) {
    case "bold":
      return /* @__PURE__ */ C(H, { size: L });
    case "book":
    case "default":
      return /* @__PURE__ */ C(t, { size: L });
  }
};
export {
  V as default
};
//# sourceMappingURL=DIconLogout.js.map
